import { render, staticRenderFns } from "./SeniorLifeMemberManualPayment.vue?vue&type=template&id=32953af6"
import script from "./SeniorLifeMemberManualPayment.vue?vue&type=script&lang=js"
export * from "./SeniorLifeMemberManualPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports